import {
    Select, Box, Button, Flex, useToast, AlertDialog, useDisclosure,
    Text,
    VStack,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay, ButtonGroup, Input,
} from '@chakra-ui/react'
import {gql, useMutation, useQuery} from "@apollo/client"
import React, {useState, useRef} from "react"

const listThemes = gql`
query ListThemes($customer_name: String = "") {
  themes(where: {customer: {_eq: $customer_name}}) {
    theme_id
    theme_name
  }
}
`

const listTopicsForTheme = gql`
query ListThemes($customer_name: String = "", $theme_id: Int) {
  topics(where: {theme_id: {_eq: $theme_id}, customer: {_eq: $customer_name}}) {
    topic_id
    topic_name
  }
}
`

const insertTopicDefinitionToExistingTopic = gql`
mutation InsertTopicDefinitionToExistingTopic($data: jsonb, $query: String = "", $topic_id: Int = 10, $semantic_search_results: [semantic_search_results_insert_input!] = {}) {
  insert_topic_definition(objects: {topic_id: $topic_id, type: "semantic_search", data: $data, query: $query, semantic_search_results: {data: $semantic_search_results}}, on_conflict: {update_columns: [data], constraint: topic_definition_pk}) {
    returning {
      topic_definition_id
    }
  }
}
`

const insertNewTopic = gql`
mutation InsertNewTopic($customer: String = "", $theme_id: Int, $query: String = "", $type: String = "", $topic_name: String = "", $data: jsonb = "", $semantic_search_results: [semantic_search_results_insert_input!] = {}) {
  insert_topics(objects: {topic_definitions: {data: {query: $query, type: $type, data: $data, semantic_search_results: {data: $semantic_search_results}}}, customer: $customer, theme_id: $theme_id, topic_name: $topic_name}) {
    affected_rows
    returning {
      topic_definitions {
        topic_definition_id
      }
    }
  }
}
`


export function AddExistingThemeForm({query, resultsLength, searchResults, searchThreshold, topk}) {
    const [selectedTheme, setSelectedTheme] = useState("");
    const [selectedTopic, setSelectedTopic] = useState("");
    const [addToExistingTopicMode, setAddToExistingTopicMode] = useState(true);
    const [newTopicName, setNewTopicName] = useState("");
    const {isOpen, onOpen, onClose} = useDisclosure()
    const toast = useToast()
    const cancelRef = useRef()
    const {loading: loadingTheme, error: errorTheme, data: dataTheme} = useQuery(listThemes,
        {'variables': {"customer_name": localStorage.getItem("customerName")}})
    const {loading: loadingTopic, error: errorTopic, data: dataTopic} = useQuery(listTopicsForTheme,
        {
            'variables': {"customer_name": localStorage.getItem("customerName"), "theme_id": selectedTheme},
            'skip': !selectedTheme
        })
    const [mutateExistingTopicFunction, {
        data: mutationExistingData,
        loading: mutationExistingLoading,
        error: mutationExistingError
    }] = useMutation(insertTopicDefinitionToExistingTopic);
    const [mutateNewTopicFunction, {
        data: mutationNewData,
        loading: mutationNewLoading,
        error: mutationNewError
    }] = useMutation(insertNewTopic);
    if (errorTheme) return `Error! ${errorTheme.message}`;
    if (loadingTheme) return <></>

    if (errorTopic) return `Error! ${errorTopic.message}`;
    console.log("earlierquery", query)

    function updateTopicDefinitionDialog() {
        console.log('query', query)
        if (!query) {
            toast({description: 'Search Query cannot be empty'})
            return
        }
        onOpen()
    }

    function submitUpdatedTopicDefinition() {
        mutateExistingTopicFunction({
            variables: {
                data: {"topk": topk, "threshold": searchThreshold},
                query: query,
                topic_id: selectedTopic,
                semantic_search_results: searchResults.map((result) => ({
                    text_id: result.text_id, score: result.data["cross-score"]
                }))
            }
        }).then((data) => {
            console.log("mutationData", data)
            console.log("topic_definition_id", data.data.insert_topic_definition.returning[0].topic_definition_id)
            let topicdefid = data.data.insert_topic_definition.returning[0].topic_definition_id
            fetch(`${process.env.REACT_APP_API_URL}/inferSemanticSentiment?topicdefid=${topicdefid}`)
                .then((response) => console.log("SUCCESSFULLY SENT REQUEST TO INFER SENTIMENT", response))
                .catch((error) => console.log("ERROR WHILE SENDING REQUEST TO INFER SENTIMENT", error))
            toast({description: `Topic updated successfully`})
        }).catch((e) => {
            toast({description: `Error while updating the existing topic. Please try again`})
        })
        onClose()
    }

    function submitNewTopicDefinition() {

        mutateNewTopicFunction({
            variables: {
                customer: localStorage.getItem("customerName"),
                theme_id: selectedTheme,
                type: "semantic_search",
                topic_name: newTopicName,
                data: {"topk": topk, "threshold": searchThreshold},
                query: query,
                semantic_search_results: searchResults.map((result) => ({
                    text_id: result.text_id, score: result.data["cross-score"]
                }))
            }
        }).then((data) => {
            console.log("mutationData", data)
            console.log("topic_definition_id", data.data.insert_topics.returning[0].topic_definitions[0].topic_definition_id)
            let topicdefid = data.data.insert_topics.returning[0].topic_definitions[0].topic_definition_id
            fetch(`${process.env.REACT_APP_API_URL}/inferSemanticSentiment?topicdefid=${topicdefid}`)
                .then((response) => console.log("SUCCESSFULLY SENT REQUEST TO INFER SENTIMENT", response))
                .catch((error) => console.log("ERROR WHILE SENDING REQUEST TO INFER SENTIMENT", error))
            toast({description: `New topic successfully created`})
        }).catch((e) => {
            console.log(e)
            toast({description: `Error while creating new topic. Please try again`})
        })

        onClose()
    }

    return (
        <>
            <VStack mt="10px">
                <Select variant='filled' backgroundColor='#FFF' borderRadius='10px' placeholder="Select theme"
                        value={selectedTheme}
                        onChange={e => setSelectedTheme(e.target.value)} w="400px">
                    {dataTheme.themes.map((opt, idx) => <option key={idx}
                                                                value={opt.theme_id}>{opt.theme_name}</option>)}
                </Select>
                {selectedTheme !== "" ?
                    <ButtonGroup size='md' isAttached variant='outline' w="400px" pt="2px">

                        <Button bgColor={addToExistingTopicMode ? '#000000' : '#FFFFFF'}
                                color={addToExistingTopicMode ? '#fff' : '#000'}
                                _hover={{}}
                                onClick={() => {
                                    setAddToExistingTopicMode(true);
                                }}>Add to existing Topic</Button>
                        <Button bgColor={addToExistingTopicMode ? '#FFFFFF' : '#000000'}
                                color={addToExistingTopicMode ? '#000' : '#fff'}
                                _hover={{}}
                                onClick={() => {
                                    setAddToExistingTopicMode(false);
                                }}>Create a new Topic</Button>
                    </ButtonGroup>
                    : null}
                {addToExistingTopicMode && selectedTheme !== "" ?
                    <Flex flexDirection='row' mt="10px">
                        <Select placeholder="Add to Topic" value={selectedTopic} variant='filled' backgroundColor='#FFF'
                                borderRadius='10px' w="400px"
                                onChange={e => setSelectedTopic(e.target.value)}>
                            {(dataTopic && !loadingTopic) ? dataTopic.topics.map((opt, idx) => <option
                                key={idx} value={opt.topic_id}>{opt.topic_name}</option>) : null}
                        </Select>
                    </Flex>
                    : null
                }
                {!addToExistingTopicMode && selectedTheme !== "" ?
                    <Input placeholder="Topic Name" bg='#FFFFFF' w="400px" mt="10px" borderRadius='10px'
                           value={newTopicName}
                           onChange={(event) => {
                               setNewTopicName(event.target.value)
                           }}/>
                    : null
                }
                <Box mt="10px">
                    <Button mr="10px"
                            isDisabled={selectedTheme === "" || (addToExistingTopicMode && selectedTopic === "") || (!addToExistingTopicMode && newTopicName === "")}
                            onClick={() => updateTopicDefinitionDialog()}>Save</Button>
                    <Button onClick={() => {
                        setNewTopicName("");
                        setSelectedTheme("");
                        setSelectedTopic("");
                        setAddToExistingTopicMode(true);
                    }}>Cancel</Button>
                </Box>
            </VStack>
            <AlertDialog
                isOpen={isOpen}
                leastDestructiveRef={cancelRef}
                onClose={onClose}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            Confirm Save?
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            This will save the query "{query}" that matched {resultsLength} results with threshold
                            of {searchThreshold}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose}>
                                Cancel
                            </Button>
                            <Button
                                onClick={addToExistingTopicMode ? submitUpdatedTopicDefinition : submitNewTopicDefinition}
                                ml={3}>
                                Confirm
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    )
}